import React from "react";
import "./style.scss";

function Export() {
  return (
    <>
      <div
        style={{
          marginTop: "10%",
        }}>
        <div id='export-purchase-order' className='d-none'>
          <div className='container'>
            <div className='header'>
              <div className='header-left'>
                <div className='header-logo'></div>

                <div className='header-logo-desc text-center'>
                  <b className='fs-14'>RUMAH SAKIT</b>
                  <br />
                  <b>AN-NISA</b>
                  <p>
                    Jl. Gatot Subroto No. 96 Km. 3 <br />
                    Telp. 5525564 (Huntin) - Fax 55791563 <br />
                    Cibodas Tangerang
                  </p>
                </div>
              </div>
              <div className='header-right'>
                <table
                  style={{
                    width: "100%",
                  }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: "100px",
                        }}>
                        Nama PBF
                      </td>
                      <td width='5%'>:</td>
                      <td
                        style={{
                          minWidth: "100px",
                        }}></td>
                    </tr>
                    <tr>
                      <td>No SP</td>
                      <td width='5%'>:</td>
                      <td
                        style={{
                          minWidth: "100px",
                        }}></td>
                    </tr>
                    <tr>
                      <td colSpan='3'>
                        <h3>SURAT PESANAN OBAT</h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className='content'>
              <table className='content-table'>
                <thead>
                  <tr>
                    <th width='5%'>Tgl</th>
                    <th width='5%'>
                      No <br />
                      Urut
                    </th>
                    <th>Jenis Barang</th>
                    <th width='8%'>Banyak</th>
                    <th width='10%'>Harga Satuan</th>
                    <th>Jumlah</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='footer'>
              <div>
                <p>Menyetujui</p>
              </div>

              <div>
                <p>Tangerang, ......................... 20 .......</p>
                <p className='text-center'>Pemohon</p>

                <br />
                <br />
                <br />
                <p className='text-center'>
                  (..............................................)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Export;
// import React from "react";

// function Export() {
//   return <div>Export</div>;
// }

// export default Export;
